var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canEdit || _vm.canDelete)?_c('card',{attrs:{"title":_vm.title,"titleBottomPadding":"8px","id":"sc-work-reports"}},[_c('SCDailyReportDx',{ref:"dailyReport"})],1):_c('div',[_c('forbidden')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }